// extracted by mini-css-extract-plugin
export var cmtSSlice = "styles-module--cmt-s-slice--3b7c9";
export var cmtSSliceColumn = "styles-module--cmt-s-slice-column--623d6";
export var cmtSSliceColumnCol = "styles-module--cmt-s-slice-column--col--3bf66";
export var cmtSSliceColumnNoPadding = "styles-module--cmt-s-slice-column--no-padding--ad049";
export var cmtSSliceContainer = "styles-module--cmt-s-slice-container--b51ce";
export var cmtSSliceContainerReverse = "styles-module--cmt-s-slice-container--reverse--f4a2c";
export var cmtSSliceContainer__container = "styles-module--cmt-s-slice-container__container--0fb81";
export var cmtSSlice__container = "styles-module--cmt-s-slice__container--5a365";